module.exports = __webpack_public_path__ + "static/img/gd3.0d7a687.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/main/gd3.png
// module id = 299
// module chunks = 34